/* eslint-disable no-unused-expressions */
import _ from 'lodash'
import React, { useState } from 'react'
import { useTheme } from 'react-jss'
import { Helmet } from 'react-helmet'
import {
  useFilter,
  useMobileMenu,
  useModal,
  useOrderMethodModal,
  useProductQuickAddModal,
  useThemeConfig,
  useUser,
} from '../../hook'
import useMemberQrCodeModal from '../../hook/use-member-qr-code-modal'
import combineClassNames from '../../helpers/combineClassNames'
import Alert from '../alert'
import Footer from '../footer'
import Header from '../header'
import ContentGroup from '../content-group'
import MiniCart from '../mini-cart'
import DineInMiniCart from '../dine-in-mini-cart'
import MenuMobile from '../menu-mobil'
import MiniCartCoupon from '../mini-cart-coupons'
import ModalDialog from '../modal-dialog'
import OrderMethodModal from '../order-method-modal'
import ProductQuickAddModal from '../product-quick-add-modal'
import Filter from '../filter'
import useStyles from './layout-style'

function LayoutView({
  children,
  cartButtonDisabled,
  login,
  onLanguageChange,
  availableLocales,
  currentLocale,
  isOpenSearch,
  handelOpenSearch,
  HeaderBottomComponent,
  HeaderTopComponent,
  FooterBottomComponent,
  FooterTopComponent,
  showOrderMethodBlocker,
  // handleOrderMethodBlockerClose,
  onCouponMarketplaceOpen,
  siteName,
  siteUrl,
}) {
  const {
    user,
  } = useUser()
  const {
    mobileMenuOpen,
    openMobileMenu,
    closeMobileMenu,
  } = useMobileMenu()
  const filterProps = useFilter()
  const modal = useModal()
  const orderMethodModalProps = useOrderMethodModal()
  const productQuickAddModalProps = useProductQuickAddModal()
  const { open: openMemberQrCodeModal } = useMemberQrCodeModal()
  const [headerHeight, setHeaderHeight] = useState(0)
  const qrCode = _.get(user, 'qrCodeValue')
  const theme = useTheme()
  const { getContentGroup } = useThemeConfig()
  const styles = useStyles({ headerHeight })
  const extraScripts = _.get(theme, 'config.pages.layout.extraScripts', [{}])
  const onHeaderLayoutChange = (rect) => {
    setHeaderHeight(_.get(rect, 'height', 0))
  }

  const customStylesContentGroupProps = getContentGroup('config.ui.layout.customStyles')

  return (
    <div className={combineClassNames([
      styles.containerFluid,
      mobileMenuOpen && styles.containerFluidOpen,
    ])}
    >
      <div className={combineClassNames([
        styles.contianerWrapper,
        mobileMenuOpen && styles.contianerWrapperOpen,
      ])}
      >
        {!_.isEmpty(_.get(theme, 'typo.fontFamilyUrl')) && (
          <Helmet>
            <link href={_.get(theme, 'typo.fontFamilyUrl')} rel="stylesheet" />
          </Helmet>
        )}
        {HeaderTopComponent}
        <Header
          className={
            combineClassNames([
              styles.header,
              mobileMenuOpen && styles.headerOpen,
              !_.isEmpty(theme.config.backgroundUrl) && styles.headerWithBackground,
            ])
          }
          cartButtonDisabled={cartButtonDisabled}
          openMenuMobile={openMobileMenu}
          onLanguageChange={onLanguageChange}
          availableLocales={availableLocales}
          currentLocale={currentLocale}
          isOpenSearch={isOpenSearch}
          handelOpenSearch={handelOpenSearch}
          onLayoutChange={onHeaderLayoutChange}
          onMemberCodeOpen={openMemberQrCodeModal}
          qrCode={qrCode}
          siteName={siteName}
          siteUrl={siteUrl}
          HeaderBottomComponent={HeaderBottomComponent}
        />
        {/* {login && <AccountMenu handleOpenMemberCode={onMemberCodeOpen} />} */}
        <div className={styles.container}>{showOrderMethodBlocker ? null : children}</div>
        {FooterTopComponent}
        <Footer
          className={!_.isEmpty(theme.config.backgroundUrl) && styles.footerWithBackground}
          useSuspense={false}
        />
        {FooterBottomComponent}
        <MiniCart />
        <DineInMiniCart />
        <MenuMobile
          login={login}
          openMenuMobile={closeMobileMenu}
          onLanguageChange={onLanguageChange}
          availableLocales={availableLocales}
          currentLocale={currentLocale}
          isOpenSearch={isOpenSearch}
          handelOpenSearch={handelOpenSearch}
          onCouponMarketplaceOpen={onCouponMarketplaceOpen}
          onMemberCodeOpen={openMemberQrCodeModal}
          qrCode={qrCode}
        />
        <MiniCartCoupon
          isOutsideCheckout
        />
        <Filter {...filterProps} />
        <OrderMethodModal
          {...orderMethodModalProps}
        />
        <ProductQuickAddModal
          {...productQuickAddModalProps}
        />
        <ModalDialog
          {...modal}
        />
      </div>
      {!_.isEmpty(extraScripts)
        && _.map(extraScripts, (script, idx) => <script key={idx} type={script.type}>{`${script.code}`}</script>)}
      {
        _.has(customStylesContentGroupProps, 'code')
        && <ContentGroup {...customStylesContentGroupProps} />
      }
      <Alert />
    </div>
  )
}

export default LayoutView
